import React from 'react';
import { CameraAlt } from '@mui/icons-material';
import { Form as Forms } from 'react-bootstrap';
import AddHeader from '../../../../components/layout/header/add';
import Form from '../../../../components/molecules/forms';
import Button from '../../../../components/molecules/buttons';
import useProductsAddProduct from './hooks';

function ProductAdd():React.ReactElement {
  const {
    product, category, formik, submitLoad, handleChangeSpeciality, productId,
    individualLoad,
  } = useProductsAddProduct();
  return (
    <div>
      <AddHeader
        primary={{ route: '/products', title: 'Products' }}
        title={product.params ? 'Edit Product' : 'Add Product'}
      />
      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 px-xl-5 mb-5 d-flex justify-content-center">
          <div className="camera-container w-100 bg-transparent rounded-circle ratio ratio-1x1 flexible-center">
            <div className="flexible-center flex-column">
              <CameraAlt sx={{ fontSize: 50, color: '#18266D' }} />
              <div className="text-secondary">Min size: 200 by 200</div>
            </div>
          </div>
        </div>
        <div className="px-4 px-xl-5">
          <div className="row">
            <div className="col-md-6">
              <Form.Default
                id="upc"
                label="UPS Code"
                placeholder="Enter UPS Code"
                value={formik.values.upc}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.upc && !!formik.errors.upc}
                errorMsg={formik.errors.upc}
                className="mb-4"
              />
            </div>
            <div className="col-md-6">
              <Form.Default
                id="name"
                label="Product Name"
                placeholder="Enter Product Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.name && !!formik.errors.name}
                errorMsg={formik.errors.name}
                className="mb-4"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Form.Default
                id="unit"
                label="Product Unit"
                placeholder="Enter Product Unit"
                value={formik.values.unit}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.unit && !!formik.errors.unit}
                errorMsg={formik.errors.unit}
                className="mb-4"
                type="number"
              />
            </div>
            <div className="col-md-6">
              <Form.ReactSelect.Default
                id="category"
                placeholder="Select Category"
                label="Select Category"
                className="mb-4"
                options={category.data.category}
                value={category.data.category?.find((x) => x.value.toString() === formik.values.category)}
                onChange={(e) => {
                  if (e) formik.setFieldValue('category', e.value);
                }}
                isInvalid={formik.touched.category && !!formik.errors.category}
                errorMsg={formik.errors.category}
                isSearchable={false}
                onBlur={formik.handleBlur}
                disabled={category.load}
              />
            </div>
          </div>
          <div className="mb-4">
            <div className="fz-14 label">Select Speciality</div>
            <div className="d-flex border border-color-stroke rounded-pill align-items-center px-4 py-2 flex-wrap">
              {category.data.speciality?.map((data) => (
                <div key={data.value} className="me-3 mt-1">
                  <Forms.Check
                    checked={formik.values.speciality.includes(data.value)}
                    onChange={(e) => handleChangeSpeciality(e, data.value)}
                    type="checkbox"
                    label={data.label}
                    style={{ fontSize: '14px' }}
                  />
                </div>
              ))}
            </div>
          </div>
          <Form.Default
            id="description"
            label="Product Description"
            placeholder="Product Description"
            as="textarea"
            rows={3}
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={formik.touched.description && !!formik.errors.description}
            errorMsg={formik.errors.description}
            className="mb-4"
          />
          <div className="mb-4" style={{ paddingLeft: '20px' }}>
            <Form.Switch
              id="isBatch"
              label="Wholesale"
              active={formik.values.isBatch}
              onClick={() => formik.setFieldValue('isBatch', !formik.values.isBatch)}
            />
          </div>
          <div className={formik.values.isBatch ? '' : 'd-none'}>
            <Form.ReactSelect.AsyncMode
              id="productId"
              label="Product Name"
              className="mb-4"
              placeholder="Enter Individual"
              optionsFetcher={productId.fetcher}
              inputValue={productId.currentSearch}
              onChangeInput={(e) => productId.setCurrentSearch(e)}
              onChangeSelected={(e) => {
                formik.setFieldValue('productId', e);
              }}
              selectedValue={formik.values.productId}
              errorMsg={formik.errors.productId}
              isInvalid={!!formik.errors.productId && formik.touched.productId}
              onBlur={formik.handleBlur}
              isDisabled={individualLoad}
            />
            <div className="row">
              <div className="col-md-6">
                <Form.Default
                  id="samsClubItemNum"
                  label="Sams Club Item Num (optional)"
                  placeholder="Enter Sams Club Item Num"
                  value={formik.values.samsClubItemNum}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="mb-4"
                />
              </div>
              <div className="col-md-6">
                <Form.Default
                  id="vistarItemNum"
                  label="Vistar Item Num (optional)"
                  placeholder="Enter Vistar Item Num"
                  value={formik.values.vistarItemNum}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="mb-4"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end p-4 px-xl-5">
          <div style={{ width: '200px', marginRight: '20px' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              outline
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="save"
              type="submit"
              label={product.params ? 'Save Changes' : 'Add Product'}
              size="lg"
              loading={submitLoad || product.load}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default ProductAdd;
